import logo from "@/assets/logo.png";
import { BUSINESS } from "@/data/site";

export const Logo = ({ className = "h-12 w-auto", testid = "logo" }) => (
  <img
    src={logo}
    alt={`${BUSINESS.name} logo`}
    className={className}
    data-testid={testid}
    draggable="false"
  />
);
